(function () {
    function getOrder(card) {
        var tagSlugs = (card.getAttribute('data-home-sort-tags') || '').trim().split(/\s+/);

        for (var index = 0; index < tagSlugs.length; index += 1) {
            var match = tagSlugs[index].match(/^hash-(\d+)$/);
            if (match) {
                return Number(match[1]);
            }
        }

        return Number.POSITIVE_INFINITY;
    }

    // Use the same internal numeric tags on the homepage and organisation pages.
    document.querySelectorAll('.home-post-feed, .organisation-post-feed').forEach(function (feed) {
        var cards = Array.prototype.slice.call(feed.querySelectorAll(':scope > .post-card'));
        var layoutSlots = cards.map(function (card) {
            return {
                dynamic: card.classList.contains('dynamic'),
                large: card.classList.contains('post-card-large')
            };
        });

        cards
        .map(function (card, index) {
            return {
                card: card,
                index: index,
                order: getOrder(card)
            };
        })
        .sort(function (left, right) {
            return left.order - right.order || left.index - right.index;
        })
        .forEach(function (item, index) {
            item.card.classList.toggle('post-card-large', layoutSlots[index].large);
            item.card.classList.toggle('dynamic', layoutSlots[index].dynamic);
            feed.appendChild(item.card);
        });
    });
})();
